<div class="pull-to-refresh py-2 text-center" #pullToRefresh>
  <div class="spinner-border"></div>
</div>
